import { createFileRoute } from "@tanstack/react-router";
import { useEffect } from "react";
import Link from "~/components/Link";
import { PageLoading } from "~/components/PageLoading";
import { WithStudentNav } from "~/components/WithStudentNav";
import { trpc } from "~/utils/trpc.client";
import {
  FileDetails,
  FileLlmSummary,
  FilePreview,
  FileSummary,
  FileTextContent,
} from "~/app/(new)/[teamId]/(with-student-nav)/students/[studentId]/files/[fileId]/components";
import { FileChat } from "~/app/(new)/[teamId]/(with-student-nav)/students/[studentId]/files/[fileId]/FileChat";

/**
 * Detailed view of a file: name, key details, summary, chat, and preview.
 */
export const Route = createFileRoute(
  "/_authed/$teamId/students/$studentId/files/$fileId",
)({
  component: StudentFilePage,
});

function StudentFilePage() {
  const { teamId, studentId, fileId } = Route.useParams();

  const fileQuery = trpc.files.getFileById.useQuery({ id: fileId });
  const meQuery = trpc.auth.me.useQuery();
  const studentQuery = trpc.students.getStudent.useQuery({ id: studentId });

  const logStudentView = trpc.students.logStudentView.useMutation();
  useEffect(() => {
    logStudentView.mutate({ studentId });
    // run once on mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [studentId]);

  if (!fileQuery.data || !meQuery.data || !studentQuery.data) {
    return (
      <WithStudentNav>
        <div className="m-auto flex h-full w-full max-w-[800px] flex-col gap-4 p-4">
          <PageLoading />
        </div>
      </WithStudentNav>
    );
  }

  const file = fileQuery.data;
  const me = meQuery.data;
  const student = studentQuery.data;

  return (
    <WithStudentNav>
      <div className="m-auto flex h-full w-full max-w-[800px] flex-col gap-4 p-4">
        <div className="flex flex-row w-full">
          <div className="breadcrumbs text-sm overflow-visible">
            <ul>
              <li>
                <Link href={`/${teamId}`}>Team Home</Link>
              </li>
              <li>
                <Link href={`/${teamId}/students/${studentId}`}>
                  {student.name}
                </Link>
              </li>
              <li>
                <span>{file.name}</span>
              </li>
            </ul>
          </div>
        </div>
        <FileDetails file={file} />
        <FileSummary file={file} />
        <FileChat file={file} />
        <FilePreview file={file} />
        <FileTextContent file={file} />
        {me.email.endsWith("@simple-iep.com") && <FileLlmSummary file={file} />}
      </div>
    </WithStudentNav>
  );
}
